import { useCallback } from "react";
import {
  useGetRolesQuery,
  useGetPermissionsQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} from "../../infrastructure";
import type {
  Role,
  CreateRolePayload,
  UpdateRolePayload,
} from "../../domain/entities/RolesPermissions";

export const useRoles = () => {
  const { data: roles, isLoading, error, refetch } = useGetRolesQuery();
  const { data: permissions } = useGetPermissionsQuery();
  const [createRoleMutation] = useCreateRoleMutation();
  const [updateRoleMutation] = useUpdateRoleMutation();
  const [deleteRoleMutation] = useDeleteRoleMutation();

  const createRole = useCallback(
    async (payload: CreateRolePayload): Promise<Role> => {
      return createRoleMutation(payload).unwrap();
    },
    [createRoleMutation]
  );

  const updateRole = useCallback(
    async (roleId: string, payload: UpdateRolePayload): Promise<Role> => {
      return updateRoleMutation({ roleId, ...payload }).unwrap();
    },
    [updateRoleMutation]
  );

  const deleteRole = useCallback(
    async (roleId: string): Promise<void> => {
      return deleteRoleMutation(roleId).unwrap();
    },
    [deleteRoleMutation]
  );

  return {
    roles: roles ?? [],
    permissions: permissions ?? [],
    isLoading,
    error,
    refetch,
    createRole,
    updateRole,
    deleteRole,
  };
};